import axios from 'axios'

class Http {

    headers = {
        headers: {
            'Application-Id': 2,
            'Application-Secret': '$2y$10$c0aexjzdcu.uvJUH.a0YZ.q.DymR4VYhKUvhjk4lPj9R8C2h7SKvK'
        }
    };

    constructor () {

        let config = {
            baseURL: process.env.REACT_APP_API_ENDPOINT,
            //baseURL: "https://hf0phwtx6j.execute-api.sa-east-1.amazonaws.com/development",
            // baseURL: "http://localhost:5000",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            timeout: 300000
        };
        this.axios = axios.create(config);
        this.configInterceptors();
    }

    get(resource, params) {
        return this.axios.get(resource, params);
    }

    post(resource, params, header) {
        return this.axios.post(resource, params, header);
    }

    delete(resource, params, header) {
        return this.axios.delete(resource, params, header);
    }

    put(resource, params, header) {
        return this.axios.put(resource, params, header);
    }

    download(resource, params) {
        return this.axios.get(resource, params);
    }

    configInterceptors = () => {
        this.axios.interceptors.request.use(this.reqConfig);
        this.axios.interceptors.response.use(res => res, this.resErrorHandler);
    };

    reqConfig = (config) => {
        const token = window.localStorage.token;

        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }
        return Promise.resolve(config);
    };

    resHandle = (response) => {
        if (response.data) {
            let data = response.data;
            if (data.erro) throw (data.message + " : " + JSON.stringify(data.result)).toString();
            return data.result
        }
    };

    resErrorHandler = (error) => {
        if (!error.response) {
            throw error;
        }
        return Promise.reject(error);
    }

}

export default new Http();
